module.exports = __webpack_public_path__ + "assets/img/lx_w_d_i_14.c593ad52.jpg";